import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { Layout, PageHeader, Breadcrumb } from 'antd'
import DataTable from '~/components/dataTable'
import ContractModal from './components/modal'
import FolderModal from './components/modalFolder'
import MoveFolderModal from './components/moveFolder'
import LinkModal from './components/modalLink'
import StripeModal from './components/modalStripe'
import ReportModal from './components/reportModal'
import { getColumns } from './columns'
import { listTemplate } from '~/states/modules/templates'
import {
	listContract,
	deleteContract,
	deleteFolder,
	deleteSelected,
	createLink,
	setShowModal,
	setShowLinkModal,
	setShowStripeModal,
} from '~/states/modules/contract'
import { uploadExternalFile } from '~/states/modules/question'
import { createSession } from '~/states/modules/analytics'
import { getCompanyInfo } from '~/states/modules/companies'

import {
	setShowModalFolder,
	createFolder,
	setChooseFolder,
	updateNewFolder,
	setInitialFolder,
	setRollBackFolder,
	setMoveFolderModal,
	setMoveFolder,
	setSelectChildren,
	listFolder,
} from '~/states/modules/folder'

import styles from './index.module.scss'
import MainLayout from '~/components/mainLayout'

import { getDocumentsByStatus } from 'states/modules/workflow'

const filterOptions = [
	{
		value: '1',
		label: 'Contratos que vencem nos próximos 15 dias',
		filter: () => {
			const today = new Date().toISOString().split('T')[0]

			const todayPlus15Days = new Date(
				new Date().getTime() + 15 * 24 * 60 * 60 * 1000
			)
				.toISOString()
				.split('T')[0]

			const newFilter = `contract_end_from=${today}&contract_end_to=${todayPlus15Days}`

			return newFilter
		},
	},
	{
		value: '2',
		label: 'Contratos que vencem nos próximos 30 dias',
		filter: () => {
			const today = new Date().toISOString().split('T')[0]

			const todayPlus30Days = new Date(
				new Date().getTime() + 30 * 24 * 60 * 60 * 1000
			)
				.toISOString()
				.split('T')[0]

			const newFilter = `contract_end_from=${today}&contract_end_to=${todayPlus30Days}`

			return newFilter
		},
	},
	{
		value: '3',
		label: 'Contratos que vencem nos próximos 60 dias',
		filter: () => {
			const today = new Date().toISOString().split('T')[0]

			const todayPlus60Days = new Date(
				new Date().getTime() + 60 * 24 * 60 * 60 * 1000
			)
				.toISOString()
				.split('T')[0]

			const newFilter = `contract_end_from=${today}&contract_end_to=${todayPlus60Days}`

			return newFilter
		},
	},
	{
		value: '4',
		label: 'Contratos que vencem nos próximos 90 dias',
		filter: () => {
			const today = new Date().toISOString().split('T')[0]

			const todayPlus90Days = new Date(
				new Date().getTime() + 90 * 24 * 60 * 60 * 1000
			)
				.toISOString()
				.split('T')[0]

			const newFilter = `contract_end_from=${today}&contract_end_to=${todayPlus90Days}`

			return newFilter
		},
	},
	{
		value: '5',
		label: 'Contratos que vencem nos próximos 120 dias',
		filter: () => {
			const today = new Date().toISOString().split('T')[0]

			const todayPlus120Days = new Date(
				new Date().getTime() + 90 * 24 * 60 * 60 * 1000
			)
				.toISOString()
				.split('T')[0]

			const newFilter = `contract_end_from=${today}&contract_end_to=${todayPlus120Days}`

			return newFilter
		},
	},
	{
		value: '6',
		label: 'Contratos ativos',
		filter: () => {
			const today = new Date().toISOString().split('T')[0]
			const newFilter = `contract_start_to=${today}&contract_end_from=${today}`

			return newFilter
		},
	},
	{
		value: '7',
		label: 'Contratos vencidos',
		filter: () => {
			const today = new Date().toISOString().split('T')[0]
			const newFilter = `contract_end_to=${today}&contract_start_to=${today}`

			return newFilter
		},
	},
]

const typeFilterOptions = [
	{
		value: '8',
		label: 'Apenas Documentos',
		filter: () => 'type=document',
	},
	{
		value: '9',
		label: 'Apenas Pastas',
		filter: () => 'type=folder',
	},
]

const Contracts = () => {
	const dispatch = useDispatch()
	const history = useHistory()
	const routerLocation = useLocation()
	const [chosenMoveRow, setchosenMoveRow] = useState({ id: -1, title: '' })
	const [showReportModal, setShowReportModal] = useState(false)

	const {
		data: contractsFromBackend,
		loading,
		pages,
		showModal,
		showLinkModal,
		showStripeModal,
		link,
		parent,
		order,
		order_by,
	} = useSelector(({ contract }) => contract)

	const loggedUser = useSelector(({ session }) => session)

	const { showFolderModal, newFolder, accessFolders, moveFolderModal } =
		useSelector(({ folder }) => folder)

	const { companyInfo } = useSelector(({ companies }) => companies)
	const { groups: workflowGroups } = useSelector(({ workflow }) => workflow)

	const models = useSelector(({ template }) =>
		template.data.map((template) => {
			let aux_context = template.config.contextAi
			if (!aux_context) {
				aux_context = false
			}
			return {
				id: template.id,
				label: template.name,
				value: template.name,
				autoTitle: template.config.auto_title.enabled,
				text_type: template.text_type,
				contextAi: aux_context,
			}
		})
	)

	const workflowFilterOptions = Object.keys(workflowGroups)
		.map((statusName) => {
			const documentsInStatus = workflowGroups[statusName]
			// Só mostra o filtro se tiver documentos
			if (documentsInStatus.length > 0) {
				return {
					value: `status-${statusName}`,
					label: `${statusName} (${documentsInStatus.length})`,
					filter: () => `current_step=${encodeURIComponent(statusName)}`,
				}
			}
			return null
		})
		.filter(Boolean)

	const allFilterOptions = [
		...workflowFilterOptions,
		...typeFilterOptions,
		...filterOptions,
		...models.map((model) => ({
			value: `template-${model.id}`,
			label: model.label,
			filter: () => `template_id=${model.id}`,
		})),
	]

	// Função para atualizar a url com mais de um filtro aplicado
	const handleQueryChange = useCallback(
		(newParams) => {
			const params = new URLSearchParams(routerLocation.search)
			const allParams = {
				...Object.fromEntries(params.entries()),
				...newParams,
			}

			const newSearch = new URLSearchParams()
			for (const [key, value] of Object.entries(allParams)) {
				if (value) {
					newSearch.set(key, value)
				}
			}

			history.push({ search: newSearch.toString() })
		},
		[history, routerLocation.search]
	)

	const handleFilterChange = (selectedValues) => {
		const values = Array.isArray(selectedValues) ? selectedValues : []

		// 1. Comece com TODOS os parâmetros da URL atual (parent, search, order_by, etc.)
		const params = new URLSearchParams(routerLocation.search)

		// 2. Defina e remova APENAS os parâmetros que são controlados por este filtro
		const filterControlledKeys = [
			'contract_end_from',
			'contract_end_to',
			'contract_start_from',
			'contract_start_to',
			'template_id',
			'type',
			'current_step', // Adicionado current_step aqui!
			'active_filters',
			'filterLabel',
		]
		filterControlledKeys.forEach((key) => params.delete(key))

		// 3. Encontre os filtros selecionados (de qualquer tipo) e adicione seus parâmetros à URL
		const selectedFilters = allFilterOptions.filter((opt) =>
			values.includes(opt.value)
		)

		if (selectedFilters.length > 0) {
			// Gera a string de query para os filtros selecionados (ex: "type=document&current_step=Aprovação Diretor")
			const combinedFilterString = selectedFilters
				.map((f) => f.filter())
				.join('&')
			const newFilterParams = new URLSearchParams(combinedFilterString)

			// Adiciona os novos parâmetros de filtro à URL
			for (const [key, value] of newFilterParams.entries()) {
				params.set(key, value)
			}

			// Salva os valores selecionados para repopular o componente de filtro
			params.set('active_filters', values.join(','))
			params.set('filterLabel', selectedFilters.map((f) => f.label).join(', '))
		}

		// 4. Sempre resete para a página 1 ao aplicar um novo filtro
		params.set('page', '1')

		// 5. Atualize a URL com a combinação dos parâmetros antigos (parent, etc) e os novos de filtro
		history.push({ search: params.toString() })
	}

	const { company_id, is_financial } = useSelector(({ session }) => session)

	useEffect(() => {
		dispatch(getCompanyInfo({ id: company_id }))
		dispatch(listTemplate({ perPage: 1000, published: true }))
		dispatch(getDocumentsByStatus())
	}, [dispatch, company_id])

	const handleCreate = (values) => {
		dispatch(setShowModal(false))
		if (companyInfo['remainingDocuments'] > 0) {
			return history.push({
				pathname: `/documents/new`,
				state: {
					modelId: values.modelId,
					documentTitle: values.title,
					parent: values.parent,
				},
			})
		} else {
			dispatch(setShowStripeModal(true))
		}
	}

	const handleCreateInFolder = (values) => {
		dispatch(setShowModal(false))

		return history.push({
			pathname: `/documents/new`,
			state: {
				modelId: values.modelId,
				documentTitle: values.title,
				parent: accessFolders[accessFolders.length - 1].id,
			},
		})
	}

	const handleCreateLinkExternal = (values) => {
		dispatch(createLink(values))
	}

	const handleCancel = () => {
		dispatch(setShowModal(false))
	}

	const handleShowModal = () => {
		dispatch(listTemplate({ perPage: 1000, published: true }))
		dispatch(setShowModal(true))
		dispatch(createSession('creation'))
	}

	const handleCreateFolder = (values) => {
		dispatch(createFolder(values))
	}

	const handleUpdate = (form) => {
		dispatch(updateNewFolder(form.getFieldsValue()))
	}

	const handleShowModalFolder = () => {
		dispatch(setShowModalFolder(true))
	}

	const handleCancelFolder = () => {
		dispatch(setShowModalFolder(false))
	}

	const handleUploadedExternalFile = (UploadedExternalFile) => {
		dispatch(uploadExternalFile({ uploadedFile: UploadedExternalFile[0] }))
	}

	const handleCancelLinkModal = () => {
		dispatch(setShowLinkModal(false))
	}

	const handleCancelStripeModal = () => {
		dispatch(setShowStripeModal(false))
	}

	const handleChooseModal = () => {
		dispatch(getCompanyInfo({ id: company_id }))
		companyInfo['remainingDocuments'] > 0
			? handleShowModal()
			: dispatch(setShowStripeModal(true))
	}

	function handleGoTo(path) {
		dispatch(setShowStripeModal(false))
		return history.push(path)
	}

	const handleMoveFolderModal = (value) => {
		dispatch(setMoveFolderModal(value))
	}

	const handleToGo = (record) => {
		if (record.is_folder) {
			// Ao clicar em uma pasta, definimos o novo pai e limpamos intencionalmente
			// TODOS os filtros para evitar conflitos como "type=folder" dentro de uma pasta.
			handleQueryChange({
				folder: record.id,
				page: 1,
				search: null,

				// --- A MÁGICA ESTÁ AQUI ---
				// Limpando explicitamente todos os parâmetros de filtro
				current_step: null,
				type: null,
				template_id: null,
				contract_end_from: null,
				contract_end_to: null,
				contract_start_to: null,
				active_filters: null,
				filterLabel: null,
			})

			// Este dispatch atualiza os breadcrumbs, está correto.
			dispatch(setChooseFolder(record))
		} else {
			history.push({
				pathname: `/documents/${record.id}`,
			})
		}
	}

	const handleDelete = (record) => {
		if (Array.isArray(record)) dispatch(deleteSelected({ ids: record, pages }))
		else if (record.is_folder) dispatch(deleteFolder({ id: record.id, pages }))
		else dispatch(deleteContract({ id: record.id, pages }))
	}

	const groupedFilters = [
		{
			label: 'Status do Workflow',
			options: workflowFilterOptions,
		},
		{
			label: 'Tipo',
			options: typeFilterOptions,
		},
		{
			label: 'Vencimento do Contrato',
			options: filterOptions,
		},
		{
			label: 'Modelos',
			options: models.map((model) => ({
				value: `template-${model.id}`,
				label: model.label,
				filter: () => `template_id=${model.id}`,
			})),
		},
	]

	// Fazer a filtragem por URL
	useEffect(() => {
		const params = new URLSearchParams(routerLocation.search)
		const queryPayload = Object.fromEntries(params.entries())

		queryPayload.page = queryPayload?.page ? parseInt(queryPayload.page, 10) : 1
		queryPayload.per_page = queryPayload?.per_page
			? parseInt(queryPayload.per_page, 10)
			: 10

		delete queryPayload.active_filters
		dispatch(listContract(queryPayload))
	}, [dispatch, routerLocation.search])

	const sortTable = (parameter) => {
		const params = new URLSearchParams(routerLocation.search)
		const currentOrder = params.get('order')
		const currentOrderBy = params.get('order_by')

		let nextOrder
		if (parameter !== currentOrderBy) {
			nextOrder = 'ascend'
		} else {
			if (currentOrder === 'ascend') nextOrder = 'descend'
			else if (currentOrder === 'descend') nextOrder = null
			else nextOrder = 'ascend'
		}

		handleQueryChange({ order_by: parameter, order: nextOrder })
	}

	const handleInitialFolder = () => {
		// Apenas limpa os parâmetros de navegação e busca da URL e volta para a página 1
		handleQueryChange({
			folder: null,
			page: 1,
			search: null,
			filter: null,
			filterLabel: null,
		})

		// A action abaixo deve apenas atualizar os breadcrumbs, sem disparar uma nova busca
		if (accessFolders.length !== 0) {
			dispatch(setInitialFolder())
		}
	}

	const handleFolderRowBack = (index) => {
		const parentFolder = accessFolders[index - 1]
		const parentId = parentFolder ? parentFolder.id : null

		// Atualiza a URL para refletir a volta para a pasta pai
		handleQueryChange({
			folder: parentId,
			page: 1,
			search: null,
			filter: null,
			filterLabel: null,
		})

		// A action abaixo deve apenas atualizar os breadcrumbs
		dispatch(setRollBackFolder(index))
	}

	const setMoveNode = (row) => {
		if (accessFolders.length) {
			dispatch(listFolder({ id: row.id, source: true }))
		} else {
			dispatch(listFolder({ id: row.id }))
		}
		dispatch(setMoveFolderModal(true))
		setchosenMoveRow(row)
	}

	const handleMoveFolder = ({ destination, parent }) => {
		dispatch(setMoveFolderModal(false))
		if (destination) {
			dispatch(
				setMoveFolder({
					document_id: chosenMoveRow.id,
					destination_id: destination[0],
					parent: parent,
				})
			)
		} else {
			dispatch(
				setMoveFolder({
					document_id: chosenMoveRow.id,
					destination_id: null,
					parent: parent,
				})
			)
		}
		dispatch(setSelectChildren({ parent }))
	}

	var listFolders = accessFolders.map((folder, index) => (
		<Breadcrumb.Item
			key={index}
			className={styles.breadcrumbs}
			onClick={() => handleFolderRowBack(index)}>
			{folder ? folder.title : null}
		</Breadcrumb.Item>
	))

	// Lê os parâmetros da URL para os breadcrumbs e props
	const currentParams = new URLSearchParams(routerLocation.search)
	const activeFilters = currentParams.get('active_filters')?.split(',') || []
	const currentSearch = currentParams.get('search')
	const currentFilterLabel = currentParams.get('filterLabel')
	const currentFilterValue = currentParams.get('filter')
	const currentOrderBy = currentParams.get('order_by')
	const currentOrder = currentParams.get('order')

	// Get the search breadcrumb from query string and add it to the list of breadcrumbs
	const searchBreadcrumb = useCallback(() => {
		return (
			<Breadcrumb.Item key="search" className={styles.breadcrumbs}>
				Resultados da Busca "{currentSearch}"
			</Breadcrumb.Item>
		)
	}, [currentSearch])

	// Filter Breadcrumb
	const filterBreadcrumb = useCallback(() => {
		return (
			<Breadcrumb.Item key="filter" className={styles.breadcrumbs}>
				Resultados Filtrados por "{currentFilterLabel}"
			</Breadcrumb.Item>
		)
	}, [currentFilterLabel])

	const [selectedContracts, setSelectedContracts] = useState([])
	const columnsConfig = useSelector(
		({ companies }) => companies.companyInfo.config.document_columns
	)

	return (
		<MainLayout selectedKey={'/'}>
			<Layout style={{ backgroundColor: '#fff' }}>
				<PageHeader>
					<Breadcrumb>
						<Breadcrumb.Item
							onClick={handleInitialFolder}
							className={styles.breadcrumbs}>
							Documentos
						</Breadcrumb.Item>
						{accessFolders.length ? listFolders : null}
						{currentSearch ? searchBreadcrumb() : null}
						{currentFilterValue ? filterBreadcrumb() : null}
					</Breadcrumb>
				</PageHeader>
				<Layout style={{ backgroundColor: '#fff' }}>
					{models.length > 0 && (
						<ContractModal
							handleCancel={handleCancel}
							handleCreate={
								accessFolders.length ? handleCreateInFolder : handleCreate
							}
							handleCreateLink={handleCreateLinkExternal}
							showModal={showModal}
							models={models}
							handleUploadedExternalFile={handleUploadedExternalFile}
						/>
					)}
					<FolderModal
						handleCancel={handleCancelFolder}
						parent={
							accessFolders.length
								? accessFolders[accessFolders.length - 1].id
								: null
						}
						handleNewFolder={handleCreateFolder}
						handleUpdate={handleUpdate}
						showModal={showFolderModal}
						newFolder={newFolder}
					/>
					<MoveFolderModal
						handleCancel={handleMoveFolderModal}
						showModal={moveFolderModal}
						handleMoveFolder={handleMoveFolder}
						parent={
							accessFolders.length
								? accessFolders[accessFolders.length - 1].id
								: null
						}
						chosenMoveRow={chosenMoveRow}
					/>
					<LinkModal
						handleOk={handleCancelLinkModal}
						showModal={showLinkModal}
						link={link}
					/>
					<StripeModal
						handleCancel={handleCancelStripeModal}
						showModal={showStripeModal}
						handleConfirm={handleGoTo}
						isFinancial={is_financial}
						modalText={
							is_financial
								? 'Se deseja criar um novo documento, por favor faça o upgrade de seu plano.'
								: 'Se deseja criar um novo documento, por favor peça para o responsável financeiro de sua empresa fazer o upgrade de seu plano.'
						}
					/>
					<ReportModal
						showModal={showReportModal}
						handleCancel={() => setShowReportModal(false)}
					/>
					<DataTable
						columns={getColumns(
							handleToGo,
							handleDelete,
							setMoveNode,
							sortTable,
							selectedContracts,
							loggedUser,
							columnsConfig,
							currentOrderBy,
							currentOrder
						)}
						dataSource={contractsFromBackend}
						pages={pages}
						searchValue={currentSearch}
						filterValue={activeFilters}
						onChangePageNumber={({ page, perPage }) =>
							handleQueryChange({ page, per_page: perPage })
						}
						onSearch={({ search }) => handleQueryChange({ page: 1, search })}
						filterOptions={loggedUser.has_contracts ? groupedFilters : []}
						onFilter={(selectedValues) => handleFilterChange(selectedValues)}
						onClickButton={handleChooseModal}
						textButton="Novo Documento"
						placeholderSearch="Buscar Documento"
						placeholderNoData={!loading ? 'Nenhum documento encontrado' : ''}
						loading={loading}
						buttons={[
							{
								title: 'Nova Pasta',
								onClick: handleShowModalFolder,
							},
							{
								title: 'Gerar relatório',
								onClick: () => setShowReportModal(true),
							},
						]}
						sortTable={sortTable}
						rowSelection={{
							columnWidth: '64px',
							selectedRowKeys: selectedContracts,
							onChange: (keys) => setSelectedContracts(keys),
							getCheckboxProps: (record) => {
								if (record.is_folder) return { disabled: true }
								else return {}
							},
							renderCell: (checked, record, index, originNode) => {
								if (record.is_folder) return null
								else return originNode
							},
						}}
					/>
				</Layout>
			</Layout>
		</MainLayout>
	)
}

export default Contracts
